import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-profile-gallery',
  templateUrl: './user-profile-gallery.component.html',
  styleUrls: ['./user-profile-gallery.component.scss']
})
export class UserProfileGalleryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
